import React from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import "./filterDate.css";


const FilterDate = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onExport,
  onReset,
  handleFilterPayment
}) => {
  return (
    <div>
      <div className="download-excel mt-2">
        <div className="date-picker">
          <input
            className="date-input"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Start Date"
          />
          <div className="range">-</div>

          <input
            className="date-input"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="End Date"
            min={startDate}
          />
        </div>
        <div className="date-picker-btns">
          <button className="filter-btn" onClick={()=>handleFilterPayment()}>Apply Range</button>
          <button className="reset-btn" onClick={onReset}>Reset</button>

          <Button variant="contained" color="primary" onClick={onExport}>
            <DownloadIcon /> Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterDate;
